// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__3hDtN","fullwindow":"BBHTML_fullwindow__3xNnl"};